import { WalletButton } from '@/components/WalletButton'
import { CryptoDaySelector } from '@/components/CryptoDaySelector'
import { MainTradingView } from '@/components/MainTradingView'
import { StreakBar } from '@/components/StreakBar'
import { ConfettiOverlay } from '@/components/ConfettiOverlay'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { BottomBar } from '@/components/BottomBar'
import { RenewalModal } from '@/components/RenewalModal'
import { useActivateTrial } from '@/hooks/useActivateTrial'

function AppContent() {
  // Первый PIN-unlock → создаём users row с trial_ends_at = now + 7d (idempotent).
  useActivateTrial()
  return (
    <>
      <ConfettiOverlay />
      <div className="flex h-dvh flex-col bg-[#0a0a0a] overflow-hidden">
        <header className="flex h-11 shrink-0 items-center justify-between gap-2 overflow-hidden px-3 py-2 sm:px-4">
          <CryptoDaySelector />
          <div className="flex min-w-0 items-center gap-2 sm:gap-3">
            <StreakBar />
            <WalletButton />
          </div>
        </header>
        <main className="flex min-h-0 flex-1 flex-col p-2 pb-1">
          <MainTradingView />
        </main>
        <BottomBar />
      </div>
      {/* Глобальная модалка продления — авто-показ при истечении подписки
          после PIN-unlock. Дублируется per-tap в MainTradingView через
          forceOpen. */}
      <RenewalModal />
    </>
  )
}

export default function App() {
  return (
    <ErrorBoundary>
      <AppContent />
    </ErrorBoundary>
  )
}
